var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormInput", {
    ref: "input",
    attrs: {
      id: _vm.id,
      name: _vm.name,
      value: _vm.formattedValue,
      type: "number",
      placeholder: _vm.placeholder,
      required: _vm.required,
      disabled: _vm.disabled,
      readonly: _vm.readonly,
      maxlength: _vm.maxlength,
      minlength: _vm.minlength,
      inputmode: "decimal",
      pattern: _vm.pattern,
      label: _vm.label,
      labelOption: _vm.labelOption,
      icon: _vm.icon,
      hint: _vm.hint,
      error: _vm.error,
      attributes: _vm.attributes
    },
    on: { keyup: _vm.onKeydown, input: _vm.onInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }